const vendBannerKey = 'vend-banner-last-viewed';
const oneday = 60 * 60 * 24 * 1000;
const now = +new Date();
const stickyClass = ['bottom-0', 'fixed', 'w-full', 'z-20'];

function isInViewport(elem) {
    const distance = elem.getBoundingClientRect();
    return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function shouldShowBanner() {
    try {
        const lastViewed = parseInt(localStorage.getItem(vendBannerKey) || '', 10);
        if (!lastViewed || now - lastViewed > oneday) {
            localStorage.setItem(vendBannerKey, now.toString(10));
            return true;
        }
    } catch (e) {
        // Ignore errors from browsers that does not support localStorage.
        if (!(e.message === 'The quota has been exceeded.')) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return false;
}

if (typeof window !== 'undefined') {
    if (document.visibilityState === 'visible' && shouldShowBanner()) {
        const bannerElement = document
            ?.querySelector('finn-footer')
            ?.shadowRoot?.querySelector('#vend-banner');
        if (bannerElement && !isInViewport(bannerElement)) {
            bannerElement.classList.add(...stickyClass);
            setTimeout(() => {
                let match = true;
                for (const stickyClassMember of stickyClass) {
                    if (!bannerElement.classList.contains(stickyClassMember)) {
                        match = false;
                    }
                }
                if (match) {
                    bannerElement.classList.remove(...stickyClass);
                }
            }, 3000);
        }
    }
}
